const imgUrl = {
    'logo' : require('./covidkayalogo.png'),
    'dohlogo' : require('./dohlogo.png'),
    'coughing' : require('./coughing.jpg')
}

export default imgUrl;